export default {
  namespaced: true, //命名空间
  state: {
    loginInfo: {},
    webSocket: null,
    webSocketUrl: '',
    webSocketMessage: null,
    webSocketBeatInterval: null,
    webSocketPrevPush: [], // 未建立好链接时缓存数据
  },
  mutations: {
    SET_LOGIN_INFO(state, payload) {
      state.loginInfo = payload
    },

    SET_WEBSOCKET(state, webSocket) {
      state.webSocket = webSocket
      if (state.webSocketBeatInterval) {
        clearInterval(state.webSocketBeatInterval);
      }
      // 发送还未建立好链接时
      let msgList = state.webSocketPrevPush;
      state.webSocketPrevPush.splice(0, state.webSocketPrevPush);
      msgList.reverse().forEach((item) => {
        state.webSocket.send(JSON.stringify(item));
      });
      // 发送心跳包
      state.webSocketBeatInterval = setInterval(function () {
        if (webSocket == null) {
          clearInterval(state.webSocketBeatInterval);
          return;
        }
        let heart = {
          cmd: 1,
          body: {},
        };
        state.webSocket.send(JSON.stringify(heart));
        console.log("web socket heart beat！");
      }, 30000);
    },

    WEBSOCKET_SEND(state, p) {
      // console.log('web socket send message ', p)
      if (state.webSocket === null || state.webSocket.readyState !== 1) {
        state.webSocketPrevPush.push(p)
        return
      }
      state.webSocket.send(JSON.stringify(p))
    },

    WEBSOCKET_PUSH(state, message) {
      state.webSocketMessage = message
    },

    WEBSOCKET_DESTROY(state) {
      console.log('web socket close！')
      if (state.webSocket != null) {
        state.webSocket.close()
        state.webSocket = null
      }
    },
  },
  actions: {
    UPDATE_LOGIN_INFO({ dispatch, commit }, payload) {
      commit('SET_LOGIN_INFO', payload)
      sessionStorage.setItem('loginInfo', JSON.stringify(payload))
      if (Object.keys(payload).length === 0) { return; }
      dispatch('WEBSOCKET_INIT', {
        url: websockethttp + '://' + window.location.host + '/ws',
        loginInfo: payload,
      })
    },

    WEBSOCKET_INIT({ dispatch, state, commit }, payload) {
      if (state.webSocket !== null && state.webSocket.readyState === 1) {
        // state.webSocket.close();
        return
      }
      let webSocket = null
      try {
        webSocket = new WebSocket(payload.url)
      } catch (e) {
        setTimeout(function() {
          if (webSocket != null && webSocket.readyState === 3) {
            dispatch('WEBSOCKET_INIT', payload)
          }
        }, 10000)
        return
      }

      webSocket.onopen = function() {
        console.log('web socket connect success !')
        // 绑定用户
        webSocket.send(
          JSON.stringify({
            cmd: 2,
            body: payload.loginInfo.id,
          })
        )
        commit('SET_WEBSOCKET', webSocket)
      }
      webSocket.onmessage = function(callBack) {
        // console.log('web socket receive data', callBack.data)
        if (callBack.data.cmd === 7) {
          webSocket.send(
            JSON.stringify({
              cmd: 8,
              body: '',
            })
          )
          return
        }
        let msg = JSON.parse(callBack.data)
        // console.log(msg);
        commit('WEBSOCKET_PUSH', msg.body)
      }
      webSocket.onerror = function(e) {
        // 错误
        console.log('web socket caught error', e)
      }
      webSocket.onclose = function(e) {
        // 关闭
        console.log('web socket close', e)
        setTimeout(function() {
          if (webSocket != null && webSocket.readyState === 3) {
            dispatch('WEBSOCKET_INIT', payload)
          }
        }, 10000)
      }
    },

    WEBSOCKET_SEND({ commit }, payload) {
      commit('WEBSOCKET_SEND', payload)
    },

    WEBSOCKET_SELECTOR({ commit }, payload) {
      commit('WEBSOCKET_SEND', {
        cmd: 5,
        body: payload,
      })
    },
    WEBSOCKET_MESSAGE({ commit }, payload) {
      commit('WEBSOCKET_SEND', {
        cmd: 12,
        body: payload,
      })
    },
    //(cmd== 10=> 字符数/cmd== 11=>GPU列表数据)
    WEBSOCKET_DATA({ commit }, payload) {
      commit('WEBSOCKET_SEND', {
        cmd: payload.type === 'STATISTIC' ? 10 : 11,
        body: payload,
      })
    },
  },
}
